<template>
  <div class="container">
    <form action="/">
      <van-search
        v-model="searchPhone"
        show-action
        placeholder="请输入手机号"
        @search="onSearch"
        @clear="onClear"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </form>
    <div class="flex">
      <div class="item title">注册手机号</div>
      <div class="item title">类型</div>
      <div class="item title">注册时间</div>
      <div class="item title">会员到期时间</div>
    </div>
    <van-pull-refresh class="content" v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="(item, index) in list" :key="index">
          <div class="flex">
            <div class="item">{{ item.phone }}</div>
            <div class="item">{{ item.isDirect == 1 ? "直推" : "间推" }}</div>
            <div class="item">{{ item.regDate }}</div>
            <div class="item">{{ item.expireTime }}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      pageSize: 10,
      searchPhone: "",
    };
  },
  mounted() {
    this.refreshing = true;
    this.onRefresh();
  },
  methods: {
    onLoad() {
      this.pageNum++;
      this.getList();
    },

    onSearch(val) {
      // console.log("onSearch", this.searchPhone);
      this.pageNum=1;
      this.getList()
    },
    onClear() {
      // console.log("onClear");
      this.pageNum=1;
      this.searchPhone = ''
      this.getList()
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      this.$request.GET({
        url: "/agent/group/pager",
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          phone:this.searchPhone
        },
        success: (obj) => {
          this.loading = false;
          if (!obj.hasNextPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          if (this.refreshing || this.pageNum == 1) {
            this.list = obj.list;
            this.refreshing = false;
          } else {
            this.list = this.list.concat(obj.list);
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
@import url("vant/lib/index.less");
.container {
  height: 100vh;
  font-size: 14px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  background-color: #ededed;
  position: relative;
}
.content {
  overflow-y: scroll;
  height: 100%;
  margin-bottom: 50px;
}

.flex {
  display: flex;
  width: 100%;
}
.item {
  flex: 1;
  height: 36px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  font-size: 16px;
  font-weight: 700;
}
.time {
  font-size: 10px;
}
</style>